// db/types.ts
var UserPermission = /* @__PURE__ */ ((UserPermission2) => {
  UserPermission2["ChangePassword"] = "Users.ChangePassword";
  UserPermission2["Impersonate"] = "Users.Impersonate";
  UserPermission2["ChangeRoles"] = "Users.ChangeRoles";
  return UserPermission2;
})(UserPermission || {});
var TokenType = /* @__PURE__ */ ((TokenType2) => {
  TokenType2["LOGIN"] = "login";
  TokenType2["SSO"] = "sso";
  TokenType2["PASSWORD_CHANGE"] = "password_change";
  return TokenType2;
})(TokenType || {});
export {
  TokenType,
  UserPermission
};
